import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import classnames from 'classnames';
import { UncontrolledTooltip } from 'reactstrap';
import { useIntl } from 'react-intl';

import { showModal } from '../../actions';

import { getMatchingSearches } from '../../helpers/Search';

const PinnedSearchesTags = ({
  openModal,
  clearFilters,
  selectedFilters,
  type,
}) => {
  const [hoveredIndex, setHoveredIndex] = useState(null);

  const intl = useIntl();

  const matchingSearches = getMatchingSearches(selectedFilters, type);

  if (matchingSearches.length === 0) {
    return (
      <>
        <div className="tag-search-pin-divider" />
        {/* eslint-disable jsx-a11y/click-events-have-key-events */}
        <div
          id="PinSearchTag"
          className="tag-search-pin"
          onMouseEnter={() => setHoveredIndex(-1)}
          onMouseLeave={() => setHoveredIndex(null)}
          role="button"
          onClick={() => openModal({
            mode: 'add',
            type,
            selectedFilters,
            className: 'pin-search-modal',
          })}
          tabIndex={0}
        >
          <span>
            <i
              className={classnames('fa-thumbtack fa-rotate-by', { far: hoveredIndex !== -1, fas: hoveredIndex === -1 })}
              style={{ '--fa-rotate-angle': '45deg' }}
            />
          </span>
        </div>
        {/* eslint-enable jsx-a11y/click-events-have-key-events */}
        <UncontrolledTooltip fade={false} placement="top" target="PinSearchTag">
          {intl.formatMessage({ defaultMessage: 'Pin search' })}
        </UncontrolledTooltip>
      </>
    );
  }

  return (
    <>
      {matchingSearches.map((m, idx) => (
        <div
          className="tag tag-search tag-search-matching"
          key={m.uuid}
        >
          {/* eslint-disable jsx-a11y/click-events-have-key-events */}
          {/* eslint-disable jsx-a11y/no-static-element-interactions */}
          <span
            id={`TagSearchMatching-${idx}`}
            className="tag-search-icon"
          >
            <i
              className="far fa-thumbtack fa-rotate-by"
              style={{ '--fa-rotate-angle': '45deg' }}
            />
          </span>
          {/* eslint-enable jsx-a11y/no-static-element-interactions */}
          {/* eslint-enable jsx-a11y/click-events-have-key-events */}
          <span className="tag-search-name">
            {m.name}
          </span>
          {/* eslint-disable jsx-a11y/click-events-have-key-events */}
          <span
            className="tag-remove"
            title={intl.formatMessage({ defaultMessage: 'Remove filters' })}
            role="button"
            tabIndex={idx}
            onClick={() => clearFilters()}
          >
            <i className="far fa-times" />
          </span>
          {/* eslint-enable jsx-a11y/click-events-have-key-events */}
        </div>
      ))}
    </>
  );
};

const mapStateToProps = state => ({
  profile: state.Auth.profile,
});

const mapDispatchToProps = dispatch => ({
  openModal: (params) => {
    dispatch(showModal('PinSearchModal', params));
  },
});

PinnedSearchesTags.propTypes = {
  openModal: PropTypes.func.isRequired,
  clearFilters: PropTypes.func.isRequired,
  selectedFilters: PropTypes.array.isRequired,
  type: PropTypes.string.isRequired,
};

export default connect(mapStateToProps, mapDispatchToProps)(PinnedSearchesTags);
